"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MyApprovalsStatus = exports.translateStrings = exports.myApprovalsTabValue = exports.myRequestsTabValue = exports.allSecretsTabValue = exports.classes = void 0;

var _externalization = require("../../externalization");

var classes = {
  secretsRequestsApprovalsContainer: 'secrets-requests-approvals-container',
  addFolderContainer: 'add-folder-container',
  addFolderLoaderContainer: 'add-folder-loader-container'
};
exports.classes = classes;
var allSecretsTabValue = 0;
exports.allSecretsTabValue = allSecretsTabValue;
var myRequestsTabValue = 1;
exports.myRequestsTabValue = myRequestsTabValue;
var myApprovalsTabValue = 2;
exports.myApprovalsTabValue = myApprovalsTabValue;
var translateStrings = {
  requestApproved: (0, _externalization.translate)('MY_APPROVALS_AND_REQUEST_MODULE.REQUEST_APPROVED'),
  requestRejected: (0, _externalization.translate)('MY_APPROVALS_AND_REQUEST_MODULE.REQUEST_REJECTED'),
  requestExpired: (0, _externalization.translate)('MY_APPROVALS_AND_REQUEST_MODULE.REQUEST_EXPIRED_TOOLTIP'),
  requestCancelled: (0, _externalization.translate)('MY_APPROVALS_AND_REQUEST_MODULE.CANCELLED_REQUEST'),
  approvalPending: (0, _externalization.translate)('MY_APPROVALS_AND_REQUEST_MODULE.APPROVAL_PENDING'),
  approvedText: (0, _externalization.translate)('MY_APPROVALS_AND_REQUEST_MODULE.APPROVED_TEXT'),
  approvalPendingText: (0, _externalization.translate)('MY_APPROVALS_AND_REQUEST_MODULE.APPROVAL_PENDING'),
  timeout: (0, _externalization.translate)('MY_APPROVALS_AND_REQUEST_MODULE.TIMEOUT_STATUS'),
  rejected: (0, _externalization.translate)('MY_APPROVALS_AND_REQUEST_MODULE.REJECTED_STATUS'),
  viewSecret: (0, _externalization.translate)('SECRETS_MODULE.VIEW_SECRET'),
  noneText: (0, _externalization.translate)('SECRETS_MODULE.NONE_TEXT')
};
exports.translateStrings = translateStrings;
var MyApprovalsStatus = {
  pending: 'pending',
  timeout: 'timeout',
  rejected: 'rejected',
  access_denied: 'access denied',
  approval_required: 'approval required',
  secretReadActionName: 'sm.secret.read',
  approved: 'approved',
  requestExpiredText: 'request expired',
  cancelled: 'withdrawn',
  requestWithdrawn: 'request withdrawn'
};
exports.MyApprovalsStatus = MyApprovalsStatus;